import React, { useEffect, useState } from 'react';

import { addModifiers } from '../../../shared/helpers';
import EditorTabInsideElement from '../EditorTab/EditorTabInsideElement';

const TabsDropdownMenu = ({
  currentTabs,
  handleCloseTab,
  handleCloseChildTab,
  handleSetTabAsActive,
  handleSetChildTabAsActive,
  progress,
  currentActiveTab,
  calculateProgress = false,
  handleRenameTab,
  handleDisableRename,
  canRename,
  renameInfo,
  isChild,
  tabsStatus,
  flashMessages,
  simulationAlphas,
  currentParentTab,
  updateTabWidth,
  checkIfTabHasIssue,
  checkIfTabHasAlpha,
}: any) => {
  const [tabHovered, setTabHovered] = useState<number>(-1);
  const [childTabHovered, setChildTabHovered] = useState<number>(-1);
  const [multiTabDropdownOpen, setMultiTabDropdownOpen] = useState<any>([]);
  useEffect(() => {
    if (currentTabs.getIn([currentActiveTab, 'childTabs']) && !multiTabDropdownOpen.includes(currentActiveTab)) {
      setMultiTabDropdownOpen(multiTabDropdownOpen.concat([currentActiveTab]));
    }
  }, [currentActiveTab]);

  return (
    <div className="tab-dropdown-menu">
      <ul role="listbox" className="tab-dropdown-menu__content">
        {currentTabs.map((currentTab: any, currentIndex: number) => {
          const isActive = currentIndex === currentActiveTab;
          const isMultiSimulation = currentTab.get('childTabs');

          const handleChildDropdownMenu = (event: any) => {
            event.stopPropagation();
            if (multiTabDropdownOpen.includes(currentIndex)) {
              setMultiTabDropdownOpen(multiTabDropdownOpen.filter((value: number) => value !== currentIndex));
            } else {
              setMultiTabDropdownOpen(multiTabDropdownOpen.concat([currentIndex]));
            }
          };
          const handlerOnCloseClick = (event: React.SyntheticEvent<HTMLSpanElement>) => {
            event.stopPropagation();
            handleCloseTab(currentIndex);
            if (updateTabWidth) {
              updateTabWidth();
            }
          };
          const setTabAsActive = (event: any) => {
            event.stopPropagation();
            if (isMultiSimulation) {
              if (!multiTabDropdownOpen.includes(currentIndex)) {
                setMultiTabDropdownOpen(multiTabDropdownOpen.concat([currentIndex]));
              }
            }
            handleSetTabAsActive(currentIndex);
          };
          const onMouseEnterTabHover = () => setTabHovered(currentIndex);
          const onMouseLeaveTabHover = () => setTabHovered(-1);

          const tabStatus = tabsStatus.getIn([currentIndex, 'parentTab', 'currentStatus']);

          const progressResult = calculateProgress === false ? progress : progress.getIn([currentIndex, 'percentageProgress']);

          const elementModifiers = isActive ? ['active'] : [];

          return (
            <li
              key={currentIndex}
              role="option"
              className={addModifiers('tab-dropdown-menu__content__element', elementModifiers)}
              onMouseEnter={onMouseEnterTabHover}
              onMouseLeave={onMouseLeaveTabHover}
            >
              <EditorTabInsideElement
                tabName={currentTab.get('tabName')}
                active={isActive}
                multi={isMultiSimulation}
                isSuperAlpha={currentTab.get('superAlpha')}
                tabWidth={200}
                progress={progressResult}
                tabElementClass="editor-tabs__tab-dropdown-element"
                currentTabWidth={200}
                onActivateClickHandler={setTabAsActive}
                onCloseClickHandler={handlerOnCloseClick}
                handleRenameTab={handleRenameTab}
                handleDisableRename={handleDisableRename}
                canRename={canRename && renameInfo && renameInfo.index === currentIndex && renameInfo.isChild === isChild}
                isChild={isChild}
                tabStatus={tabStatus}
                isDropdownMenu={true}
                handleChildDropdownMenu={handleChildDropdownMenu}
                isChildDropdownMenuOpen={multiTabDropdownOpen.includes(currentIndex) && isMultiSimulation}
                tabHovered={tabHovered === currentIndex && childTabHovered === -1}
              />
              {multiTabDropdownOpen.includes(currentIndex) && isMultiSimulation && (
                <ul role="listbox" className="tab-dropdown-menu__content__child-tabs">
                  {currentTab.get('childTabs').map((currentChildTab: any, currentChildIndex: number) => {
                    const childIsActive = isActive && currentTab.get('activeChildTab') === currentChildIndex;
                    const childElementModifiers = childIsActive ? ['active'] : [];
                    const setChildTabAsActive = () => handleSetChildTabAsActive(currentChildIndex, currentIndex);
                    const handlerOnChildCloseClick = (event: React.SyntheticEvent<HTMLSpanElement>) => {
                      event.stopPropagation();
                      handleCloseChildTab(currentChildIndex, currentIndex);
                      if (updateTabWidth) {
                        updateTabWidth();
                      }
                    };
                    const onMouseEnterChildTabHover = () => setChildTabHovered(currentIndex * 100 + currentChildIndex);
                    const onMouseLeaveChildTabHover = () => setChildTabHovered(-1);

                    const childTabStatus = tabsStatus.getIn([currentIndex, 'childTabs', currentChildIndex, 'currentStatus']);

                    return (
                      <li
                        key={currentChildIndex}
                        role="option"
                        className={addModifiers('tab-dropdown-menu__content__element', childElementModifiers)}
                        onMouseEnter={onMouseEnterChildTabHover}
                        onMouseLeave={onMouseLeaveChildTabHover}
                      >
                        <EditorTabInsideElement
                          tabName={currentChildTab.get('tabName')}
                          active={childIsActive}
                          multi={isMultiSimulation}
                          tabWidth={200}
                          progress={progressResult}
                          tabElementClass="editor-tabs__child-tab-dropdown-element"
                          currentTabWidth={200}
                          onActivateClickHandler={setChildTabAsActive}
                          onCloseClickHandler={handlerOnChildCloseClick}
                          handleRenameTab={handleRenameTab}
                          handleDisableRename={handleDisableRename}
                          canRename={canRename && renameInfo && renameInfo.index === currentChildIndex && renameInfo.isChild === isChild}
                          isChild={true}
                          tabStatus={childTabStatus}
                          isDropdownMenu={true}
                          tabHovered={childTabHovered === currentIndex * 100 + currentChildIndex}
                        />
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TabsDropdownMenu;
